(function ShipCategories($, Adzuki)
{
	"use strict";
	$(document).ready(function documentReady()
	{
		if ($(".ship-categories").length > 0) {
			$('.category-details').click(function showCategoryModal(e) {
				var $self       = $(this),
					$modal      = $('.modal'),
					$modal_body = $modal.find('.modal-body'),
					$img        = $('<img class="deck-image img-responsive"/>'),
					url         = $self.data('image'),
					title       = $self.data('name'),
					description = Adzuki.String.decodeEntities($self.data('description'));

				e.preventDefault();

				$img.attr('src', Adzuki.base_uri + '/' + url);
				$img.attr('alt', title);
				$img.css('margin', 'auto').css('display', 'block');
				$modal_body.html('');
				$img.appendTo($modal_body);
				$modal_body.append('<hr>' + description);

				$modal.find('.modal-dialog').addClass('modal-lg');
				$modal.find('.modal-title').text(title);

				$modal.modal();

			});
		}
	});

}(jQuery, window.Adzuki || {}));
